<div class="app__mobile--header--menu" #menuContainer>
  <div class="app__mobile--header--menu--item">
    @for (tab of tabs; track tab; let index = $index) {
    <div
      class="app__mobile--header--menu--stepItem app__stepper__config-stepitem"
      [ngClass]="{
        'app__stepper__config-stepitem-completed': (!isDiscovery && tab?.completed) || (isDiscovery && tab?.status == 'complete'),
        'app__stepper__config-stepitem-notcompleted': (!tab?.completed && !isDiscovery) || (isDiscovery && tab?.status !== 'complete'),
        'app__mobile--header--active--menu':
          index == selected.value && ((!isDiscovery && !tab?.completed) || (isDiscovery && tab?.status != 'complete'))
      }"
      (click)="((!isDiscovery && !tab?.completed) || (isDiscovery && tab?.status != 'complete')) && menuSelectEvent(index)"
      [id]="index"
    >
      <span>{{ tab?.name }}</span>
    </div>
    }
  </div>
</div>
